import { useAuth0 } from "@auth0/auth0-react";
import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Table } from "reactstrap";
import { Message } from 'primereact/message';
import { useGames } from "../../../GamesProvider";
import { calculateTime } from "../Helpers/PracticeFunctions";
import { getRoundsCallbackList, getRoundsSemesterCallbackList } from "../../stats_components/StatsAPICall";
import { MultiSelectPlayers } from "../../dropdowns/MultiSelectPlayers";
import { MultiSelectGames } from "../../dropdowns/MultiSelectGames";
import Strengths from "../../stats_components/Strengths";
import Weaknasses from "../../stats_components/Weaknesses";
import { fillAnalysis } from "../../stats_components/AnalysisFive";
import { MultiSelect } from "primereact/multiselect";
import PlannerTimeAndNumber from "../Helpers/PlannerTimeAndNumber";
import Facilities from "../Helpers/Facilities";
import TimeFilters from "../Helpers/TimeFilters";
const GroupPlanner = (props) => {
    const [scoreAverage, setScoreAverage] = useState("");
    const [totalImprovement, setTotalImprovement] = useState("");
    const [newScoreAverage, setNewScoreAverage] = useState("");
    const { user, loginWithRedirect, getAccessTokenSilently } = useAuth0();
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [displayedPlayers, setDisplayedPlayers] = useState([]);
    const [allUserAccounts] = useState(props.allUserAccounts);
    useEffect(() => {
        if (selectedUsers.length > 0) {
            setDisplayedPlayers(selectedUsers);
        } else {
            setDisplayedPlayers(allUserAccounts)
        }
    }, [selectedUsers, allUserAccounts])
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [totalMinutes, setTotalMinutes] = useState(0);
    const [elements, setElements] = useState(1);
    const [roundType, setRoundType] = useState("All");
    const [numberOfRounds, setNumberOfRounds] = useState(10);
    const [timeDuration, setTimeDuration] = useState(0);
    const [durationType, setDurationType] = useState("number");
    const [custom, setCustom] = useState(false);
    const [stats, setStats] = useState(null);
    const roundTypes = ["All", "Tournament", "Qualifying", "Practice"]
    const durations = ["Last Round", "Last 3 Rounds", "Last 4 Rounds", "Last 10 Rounds", "Last 15 Rounds",
        "Last 20 Rounds", "Last 30 Rounds", "Last Month", "Last 3 Months", "Last 6 Months", "Last 12 Months", "Fall", "Spring",];
    const options = ['Name', 'Total', 'Attempts', 'PerShot', 'Improvement', 'Time'];
    const practiceOptions = ['Name', 'Total', 'Time'];

    const facilities = ["Range Driver", "Range Irons", "Range Woods", "Short Game Area", "Putting Green"];
    const [selectedFacilities, setSelectedFacilities] = useState(facilities)

    const gamesConst = useGames();
    const [selectedGames, setSelectedGames] = useState({});
    const [state, setState] = useState(() => {
        const initialState = {};
        for (var i = 1; i < 8; i++) {
            options.forEach((option) => {
                initialState[`analysis${i}${option}`] = '';
                initialState[`strength${i}${option}`] = '';
            })
        }
        return initialState;
    })
    const [numberImprovement, setNumberImprovement] = useState(2);
    const [numberStrength, setNumberStrength] = useState(1);
    const [units, setUnits] = useState("yards")

    const [loadingButton, setLoadningButton] = useState(false)
    const green = "rgba(0, 128, 0, 0.75)";
    const red = "rgba(220, 0, 0, 0.75)"

    const [statsType, setStatsType] = useState("Basic");

    useEffect(() => {
        switch (elements) {
            case 3:
                setNumberImprovement(2);
                setNumberStrength(1);
                break;
            case 4:
                setNumberImprovement(3);
                setNumberStrength(1);
                break;
            case 5:
                setNumberImprovement(3);
                setNumberStrength(2);
                break;
            case 6:
                setNumberImprovement(4);
                setNumberStrength(2);
                break;
            case 7:
                setNumberImprovement(5);
                setNumberStrength(2);
                break;
            case 8:
                setNumberImprovement(5);
                setNumberStrength(3);
                break;
            case 9:
                setNumberImprovement(6);
                setNumberStrength(3);
                break;
            case 10:
                setNumberImprovement(7);
                setNumberStrength(3);
                break;
        }
    }, [elements])

    async function getRounds() {
        setLoadningButton(true);
        if (durationType.toLowerCase() === "fall") {
            getRoundsSemesterCallbackList(
                displayedPlayers,
                "2023-08-25",
                "2023-10-29",
                roundType,
                (data) => { setStats(data); setLoadningButton(false) }
            )
        } else if (durationType.toLowerCase() === "spring") {
            getRoundsSemesterCallbackList(
                displayedPlayers,
                "2023-02-10",
                "2023-05-01",
                roundType,
                (data) => { setStats(data); setLoadningButton(false) }
            )
        } else {
            getRoundsCallbackList(
                displayedPlayers,
                durationType,
                timeDuration,
                numberOfRounds,
                roundType, (data) => { setStats(data); setLoadningButton(false) }
            )
        }
    }


    useEffect(() => {
        if (stats !== null)
            calculateTime(
                fillAnalysis(stats, units, setState, setScoreAverage, setTotalImprovement, setNewScoreAverage, selectedFacilities, numberImprovement, numberStrength, statsType !== "Basic"),
                numberImprovement, numberStrength, totalMinutes, setState);
    }, [stats])


    useEffect(() => {
        setTotalMinutes(hours * 60 + minutes)
    }, [hours, minutes])

    function sendEmail(players) {
        var emails = []
        players.forEach((p) => {
            emails.push(p.email)
        })
        var subject = `Team Practice`
        var time = ""
        for (var i = 1; i <= numberStrength; i++) {
            time += `${state[`strength${i}Name`]}: ${state[`strength${i}Time`]}min%0D%0A`
        }
        time += "%0D%0A"
        for (var i = 1; i <= numberImprovement; i++) {
            time += `${state[`analysis${i}Name`]}: ${state[`analysis${i}Time`]}min%0D%0A`
        }
        time += "%0D%0A"
        var puttingGames = selectedGames.puttingGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var argGames = selectedGames.argGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var appGames = selectedGames.appGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var teeGames = selectedGames.teeGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";
        var combineGames = selectedGames.combineGames?.map((g) => ` ${g.name}%0D%0A`).join('') ?? "none%0D%0A";

        var body = `Time:%0D%0A${time}%0D%0A Putting games:%0D%0A${puttingGames}%0D%0A Arg games:%0D%0A${argGames}%0D%0A Approach games:%0D%0A${appGames}%0D%0A Tee games:%0D%0A${teeGames}%0D%0A Combines:%0D%0A${combineGames}`
        window.open(`mailto:${emails}?subject=${subject} &body=${body}`, '_blank')
    }

    return (
        <div>
            <Card className="mt-2 mb-2" title="Plan team's day" >
                <PlannerTimeAndNumber hours={hours} setHours={setHours} minutes={minutes} setMinutes={setMinutes}
                    elements={elements} setElements={setElements} />
                <TimeFilters roundType={roundType} setRoundType={setRoundType} durations={durations} setNumberOfRounds={setNumberOfRounds}
                    setDurationType={setDurationType} setTimeDuration={setTimeDuration} setCustom={setCustom} statsType={statsType} setStatsType={setStatsType} />
                <Facilities selectedFacilities={selectedFacilities} setSelectedFacilities={setSelectedFacilities} statsType={statsType} />
                <MultiSelectPlayers players={props.players} selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} durations={durations} coachTeam={props.coachTeam} />

                <Button loading={loadingButton} className="m-2" disabled={totalMinutes <= 0 && selectedUsers.length <= 0} label="Plan my practice"
                    onClick={() => getRounds()} />
            </Card >
            {
                <div>
                    <Card className="mt-2 mb-2">

                        <Strengths state={state} data={stats} />
                        <Weaknasses state={state} data={stats} scoreAverage={scoreAverage} totalImprovement={totalImprovement} newScoreAverage={newScoreAverage} />

                    </Card>
                    <Card className="mt-2 mb-2" title="Suggested Practice">
                        {stats && <Message className='m-3' severity="info" text={`${stats.noOfRounds} round${stats.noOfRounds === 1 ? "" : "s"}`} />}

                        <div className="table-responsive">
                            <Table id='strengthtable' className='stats-table'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Total SG</th>
                                        <th>Time (min)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: numberImprovement }).map((_, index) => (
                                        <tr style={{
                                            color: "white",
                                            backgroundColor: red
                                        }}>
                                            {practiceOptions.map((option) => (
                                                <td className={`${stats === null && 'loading-cell '} data-cell`}>{state[`analysis${index + 1}${option}`]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                    {Array.from({ length: numberStrength }).map((_, index) => (
                                        <tr style={{
                                            color: "white",
                                            backgroundColor: green
                                        }}>
                                            {practiceOptions.map((option) => (
                                                <td className={`${stats === null && 'loading-cell '} data-cell`}>{state[`strength${index + 1}${option}`]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <MultiSelectGames games={gamesConst.puttingGames} selectedGames={selectedGames.puttingGames || []}
                                setSelectedGames={(games) => {
                                    setSelectedGames((prev) => ({
                                        ...prev,
                                        puttingGames: games,
                                    }));
                                }} part="Putting" />
                            <MultiSelectGames games={gamesConst.argGames} selectedGames={selectedGames.argGames || []}
                                setSelectedGames={(games) => {
                                    setSelectedGames((prev) => ({
                                        ...prev,
                                        argGames: games,
                                    }));
                                }} part="Arg" />
                            <MultiSelectGames games={gamesConst.appGames} selectedGames={selectedGames.appGames || []}
                                setSelectedGames={(games) => {
                                    setSelectedGames((prev) => ({
                                        ...prev,
                                        appGames: games,
                                    }));
                                }} part="Approach" />
                            <MultiSelectGames games={gamesConst.teeGames} selectedGames={selectedGames.teeGames || []}
                                setSelectedGames={(games) => {
                                    setSelectedGames((prev) => ({
                                        ...prev,
                                        teeGames: games,
                                    }));
                                }} part="Tee" />
                            <MultiSelectGames games={gamesConst.combineGames} selectedGames={selectedGames.combineGames || []}
                                setSelectedGames={(games) => {
                                    setSelectedGames((prev) => ({
                                        ...prev,
                                        combineGames: games,
                                    }));
                                }} part="Combine" />
                            <div>
                                <label>Selected games:</label>
                                {selectedGames.puttingGames?.map((game) => (
                                    <li>{game.name}</li>
                                ))}
                                {selectedGames.argGames?.map((game) => (
                                    <li>{game.name}</li>
                                ))}
                                {selectedGames.appGames?.map((game) => (
                                    <li>{game.name}</li>
                                ))}
                                {selectedGames.teeGames?.map((game) => (
                                    <li>{game.name}</li>
                                ))}
                                {selectedGames.combineGames?.map((game) => (
                                    <li>{game.name}</li>
                                ))}
                            </div>
                            <Button label="Send" onClick={() => sendEmail(selectedUsers)} />

                        </div>
                    </Card></div>}
        </div >
    )

}
export { GroupPlanner }